// ⛔️Generated file. Manual changes will be lost ⛔️

import {
    Operation,
    MessagingClient,
    ServiceClient,
} from '@multipass-system';
import {
    GetI18nCatalogResponseDto,
    LogBatchRequestDto,
    LogBatchResponseDto
} from '@multipass-platform-service-dto';

export class PlatformServiceOperations {

    static GetI18nCatalog: Operation = {
        'key': 'multipass-platform-service_GetI18nCatalog',
        'name': 'GetI18nCatalog',
        'version': '1.0.0',
        'route': '/platform-svc/i18n/{locale}',
        'method': 'GET',
    };

    static SendLogs: Operation = {
        'key': 'multipass-platform-service_SendLogs',
        'name': 'SendLogs',
        'version': '1.0.0',
        'route': '/platform-svc/logs',
        'method': 'POST',
    };

}

export interface PlatformServiceClient extends ServiceClient {
    requestGetI18nCatalog(locale: string, timeoutInMs?: number): Promise<GetI18nCatalogResponseDto>;
    requestSendLogs(request: LogBatchRequestDto, timeoutInMs?: number): Promise<LogBatchResponseDto>;
}

const DefaultTimeoutInMs = 20_000;

export class PlatformServiceClientImpl implements PlatformServiceClient {

    constructor(private _messagingClient: MessagingClient) {}

    public requestGetI18nCatalog(locale: string, timeoutInMs: number = DefaultTimeoutInMs): Promise<GetI18nCatalogResponseDto> {
        return this._messagingClient.request<{locale: string}, GetI18nCatalogResponseDto>(
            PlatformServiceOperations.GetI18nCatalog,
            {locale},
            {timeoutMs: timeoutInMs}
        );
    }

    public requestSendLogs(request: LogBatchRequestDto, timeoutInMs: number = DefaultTimeoutInMs): Promise<LogBatchResponseDto> {
        return this._messagingClient.request<LogBatchRequestDto, LogBatchResponseDto>(
            PlatformServiceOperations.SendLogs,
            request,
            {timeoutMs: timeoutInMs}
        );
    }
}
